<div class="p-4">
  <div class="d-flex justify-content-between">
    <div class="ticket-archive-modal__title">{{ 'archive.process_l' | translate }}</div>
    <rs-web-icon
      [cursor]="'pointer'"
      [size]="20"
      [icon]="immomioIconName.Close"
      (tapped)="activeModal.dismiss()"
    ></rs-web-icon>
  </div>
  <div class="pt-4">
    {{ 'archive.ticket.description.first.line_l' | translate: { ticketName: ticketName } }}
  </div>
  <div class="py-4">{{ 'archive.ticket.description.second.line_l' | translate }}</div>
  <div class="d-flex gap-3">
    <button im-button class="inverted flex-grow-1" (click)="activeModal.dismiss()">
      {{ 'general.cancel' | translate }}
    </button>
    <button im-button class="primary flex-grow-1" (click)="activeModal.close()">
      {{ 'archive.ticket_a' | translate }}
      <i iconEnd [class]="'icon-' + immomioIconName.Archive"></i>
    </button>
  </div>
</div>
